/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { CountryTable } from "./CountryTable";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { Row, Col, Image, Space } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Button, TextField, Box } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import currencyActions from "../../../Setup/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const Country = (props) => {
    const { createDetails, createError, createLoader, getList, getData } = useSelector(state => state.crudReducer);
    const { countryDetails, countryLoader } = useSelector(state => state.addressReducer);
    const { currencyDetails } = useSelector(state => state.adminSetupReducer);
    const [visible, setVisible] = useState(false);
    const [countryName, setCountryName] = useState('');
    const [longName, setLongName] = useState('');
    const [currencyId, setCurrencyId] = useState('');
    const [currencySymbol, setCurrencySymbol] = useState('');
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [errorCountryName, setErrorCountryName] = useState(false);
    const [errorLongName, setErrorLongName] = useState(false);
    const [errorCurrencySymbol, setErrorCurrencySymbol] = useState(false);
    const [errorCurrencyId, setErrorCurrencyId] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);

    const type = 'import';
    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { moduleType } = props;

    const handleOpen = () => {
        setVisible(true);
        emptyStateInput();
        emptyState();
    };
    const handleClose = () => {
        setVisible(false);
        emptyStateInput();
        emptyState();
    };

    const emptyState = () => {
        setErrorCountryName(false);
        setErrorLongName(false);
        setErrorCurrencyId(false);
        setErrorCurrencySymbol(false);
    }

    const emptyStateInput = () => {
        setCountryName('');
        setLongName('');
        setCurrencyId('');
        setCurrencySymbol('');
    }
    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.COUNTRY_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'country',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const dispatch = useDispatch();
    const createCountry = (e) => {
        let emptyCountryName = emptyValidation('Country Name', countryName);
        let emptyLongName = emptyValidation('Long Name', longName);
        let emptyCurrencyId = emptyValidation('Currency', currencyId, 'dropDown');
        emptyState();
        e.preventDefault();
        if (emptyCountryName.isValid && emptyLongName.isValid && emptyCurrencyId.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'country',
                title: "Country",
                details: {
                    name: countryName,
                    longName: String(longName),
                    currencyId: currencyId
                }
            });
        } else {
            if (emptyCountryName.errors !== '') {
                setErrorCountryName(emptyCountryName.errors);
            } if (emptyLongName.errors !== '') {
                setErrorLongName(emptyLongName.errors);
            } if (emptyCurrencyId.errors !== '') {
                setErrorCurrencyId(emptyCurrencyId.errors);
            }
        }
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);


    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useEffect(() => {
        if (roleManagement !== '') {
            loadTasks();
        }
    }, [roleManagement]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ longName: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'country',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: currencyActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(sortBy, sortOrder);
    });

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorCountryName(error);
        }
    }, [createDetails, createError]);

    const changeCurrency = (value) => {
        let currency = currencyDetails.filter(function (el) { return el.id === value });
        setCurrencyId(value);
        if (currency && currency.length > 0) {
            setCurrencySymbol(currency[0].symbol);
        } else {
            setCurrencySymbol('');
        }
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleOpenImport = () => {
        setImportVisible(true);
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    const onExport = () => {
        loadImportExportData('Country');
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={moduleType !== undefined ? moduleType : 'Younote Admin'}
                links={[{ 'label': moduleType !== undefined ? moduleType : 'Younote Admin', 'link': moduleType === 'Admin' ? '/admin' : '/younote-admin' },
                { 'label': 'Address Management', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Country'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Country', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Country', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    className={clsx(classes.customLink)}
                                                    onClick={() => onExport()}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Country', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    className={clsx(classes.customLink)}
                                                    onClick={() => handleOpenImport()}
                                                >
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && (checkCRUDPermission('Country', 'create', 'Younote Admin') || checkCRUDPermission('Country', 'create', 'Admin')) &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Add</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Country', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <CountryTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                moduleType={moduleType}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                customObject={(details, id) => customObject(details, id)}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add Country'}
                    width={"360px"}
                    className={classes.closeBackGround}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createCountry(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Country Name ", <span key={"Country Name"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorCountryName && true}
                                    helperText={errorCountryName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setCountryName(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Long Name'
                                    variant={'standard'}
                                    error={errorLongName && true}
                                    helperText={errorLongName}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setLongName(e.target.value)}
                                />
                                <AutoCompleteComponent
                                    name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                    { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                    details={currencyDetails}
                                    parentValue={customObject(currencyDetails, currencyId)}
                                    onChange={(data) => changeCurrency(data.id)}
                                    parentError={errorCurrencyId}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Currency Symbol'
                                    variant={'standard'}
                                    value={currencySymbol}
                                    className={clsx(classes.margin20t)}
                                    error={errorCurrencySymbol && true}
                                    helperText={errorCurrencySymbol}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    customClasses={classes.margin30t}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    disabled
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Button
                                    key="yes"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}

                                >
                                    Save
                                </Button>
                            </div>
                        </Box>
                    }
                />
                <ImportExport
                    handleClose={() => handleImportClose()}
                    visible={importVisible}
                    title={'Country'}
                    type={type}
                    details={countryDetails}
                    loader={countryLoader}
                    loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                    loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
                />
            </div>
        </React.Fragment >
    )
}

export default Country